import { Injectable } from '@angular/core';
import { environment } from '../../../env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DossierService {

  host_Dossier = `${environment.API_URI}/api/dossier`;

  constructor(private http: HttpClient) { }

  private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  getDossiersByDo(code_DO: number) {
    const url = `${this.host_Dossier}/all/${code_DO}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }
  DeleteOneOrManyDossiers(code_Internes: number[]) {
    const url = `${this.host_Dossier}/delete`;
    const options = {
      headers: this.getAuthHeaders(),
      body: { code_interne: code_Internes }
    };
    return this.http.delete(url, options);
  }

exportDossierByDo(code_Do: number): Observable<Blob> {
    const url = `${this.host_Dossier}/export/${code_Do}`;
    return this.http.post<Blob>(url, null, {
      headers: this.getAuthHeaders(),
      responseType: 'blob' as 'json' 
    });
  }
}
